import { render, staticRenderFns } from "./PaymentTransaction.vue?vue&type=template&id=06bc6b5d&"
import script from "./PaymentTransaction.vue?vue&type=script&lang=js&"
export * from "./PaymentTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports